import React from 'react';
export function Footer() {
  return <footer className="bg-volley-navy-dark text-white/70 py-12 px-4 text-center text-sm border-t border-white/5" data-id="element-99">
      <div className="max-w-3xl mx-auto space-y-6" data-id="element-100">
        <p className="font-medium" data-id="element-101">
          © {new Date().getFullYear()} Volley Pronto — Tutti i diritti
          riservati.
        </p>
        <p className="text-xs text-white/50 max-w-2xl mx-auto leading-relaxed" data-id="element-102">
          Il contenuto di questa pagina è a scopo informativo ed educativo. Non
          sostituisce una formazione professionale certificata. Consulta un
          professionista prima di iniziare qualsiasi attività fisica.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 text-xs text-white/60 pt-4" data-id="element-103">
          <a href="#" className="hover:text-white transition-colors" data-id="element-104">
            Termini e Condizioni
          </a>
          <span className="text-white/30" data-id="element-105">·</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-106">
            Privacy Policy
          </a>
          <span className="text-white/30" data-id="element-107">·</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-108">
            Contatti
          </a>
        </div>
      </div>
    </footer>;
}